import GetAppIcon from "@mui/icons-material/GetApp";
import PrintIcon from "@mui/icons-material/Print";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
  Toolbar,
} from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useTranslation } from "@refinedev/core";
import { DateField, EditButton, ShowButton, useDataGrid } from "@refinedev/mui";
import { List } from "pages/in-stock/components/List";
import React, { useState } from "react";
import { ClientCreate } from "./create";

export const ClientList = () => {
  const { translate } = useTranslation();
  const { dataGridProps } = useDataGrid();
  const [open, setOpen] = useState<boolean>(false);

  const [searchDate, setSearchDate] = useState("");
  const handleExportExcel = () => {
    // Implement export to Excel logic here
  };

  const handlePrintInvoice = () => {
    // Implement print invoice logic here
  };

  const onClose = () => {
    setOpen(false);
  };

  const normalizedSearch = searchDate.trim().toLowerCase();
  const filteredRows = React.useMemo(() => {
    const rows = (dataGridProps.rows as any[]) ?? [];
    if (!normalizedSearch) {
      return rows;
    }

    return rows.filter((row) => {
      const name = String(row?.name ?? "").toLowerCase();
      const pseudo = String(row?.pseudo ?? "").toLowerCase();
      const phone = String(row?.phone ?? "").toLowerCase();
      const color = String(row?.color ?? "").toLowerCase();

      return (
        name.includes(normalizedSearch) ||
        pseudo.includes(normalizedSearch) ||
        phone.includes(normalizedSearch) ||
        color.includes(normalizedSearch)
      );
    });
  }, [dataGridProps.rows, normalizedSearch]);

  const columns = React.useMemo<GridColDef<any>[]>(
    () => [
      {
        field: "name",
        headerName: translate('name'),
        minWidth: 200,
      },
      {
        field: "phone",
        headerName: translate('phone'),
        type: "number",
        minWidth: 200,
      },
      {
        field: "color",
        headerName: "Color",
        type: "string",
        minWidth: 200,
      },
      {
        field: "pseudo",
        headerName: "Pseudo",
        minWidth: 250,
      },
      {
        field: "actions",
        headerName: translate('table.actions'),
        renderCell: function render({ row }) {
          return (
            <>
              <EditButton hideText recordItemId={row.id} />
              <ShowButton hideText recordItemId={row.id} />
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        minWidth: 80,
      },
    ],
    []
  );

  return (
    <List open={open} setOpen={setOpen}>
      <Stack direction="row" alignContent="end" justifyContent="end" mb={2}>
        <Toolbar>
          <TextField
            label={translate('search')}
            value={searchDate}
            onChange={(e) => setSearchDate(e.target.value)}
            variant="outlined"
            sx={{ mr: 2 }}
          />
          <IconButton onClick={handleExportExcel}>
            <GetAppIcon />
          </IconButton>
          <IconButton onClick={handlePrintInvoice}>
            <PrintIcon />
          </IconButton>
        </Toolbar>
      </Stack>
      <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
        <ClientCreate onClose={onClose} />
      </Dialog>
      <DataGrid {...dataGridProps} rows={filteredRows} columns={columns} autoHeight />
    </List>
  );
};
